import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: 'normalize'
})
export class NormalizePipe implements PipeTransform {
	transform(value: any) {
        let components = value.split("_");

        let computedString = "";

        for (let i = 0; i < components.length; i++) {
            let component = components[i];

            let upperCaseComponent = component.charAt(0).toUpperCase() + component.slice(1);

            computedString += upperCaseComponent;

            if (i != components.length - 1) {
                computedString += " ";
            }
        }

		return(computedString);
	}
}